<template>
	<div class="per_right">
		<div class="per_right_1 clearfix">
			<img src="@/images/center_title.png" class="per_right_1back"/>
			<img src="@/images/center_text3.png" class="per_right_1name"/>
		</div>
		<div class="per_right_2">
			<div class="right-filter">
				<el-form :inline="true" :model="form">
					<el-form-item label="考试状态：">
						<el-select v-model="form.state" placeholder="考试状态" clearable>
							<el-option :label="item.label" :value="item.value" :key="item.value" v-for='item in types'></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="考试名称：">
						<el-input v-model="form.examineName" placeholder="请输入考试名称关键词"></el-input>
					</el-form-item>
					<el-form-item>
						<div class="feedback_button" @click="onSubmit">
							<img src="@/images/zy_button.png" class="feedback_back" />
							<span>查询</span>
						</div>
					</el-form-item>
				</el-form>
			</div>
			<div class="right-table examTable">
				<el-table :data="dataList" stripe style="width: 100%">
					<el-table-column prop="name" label="考核名称">
					</el-table-column>
					<el-table-column prop="date" label="考核时间" align="center">
						<template slot-scope="scope">
							{{scope.row.beginTime | spliceForHalfData}} 至 {{scope.row.endTime | spliceForHalfData}}
						</template>
					</el-table-column>
					<el-table-column prop="timeSpent" label="限定时间" width='100' align="center">
						<template slot-scope="scope">
							{{scope.row.timeSpent || '-'}}
						</template>
					</el-table-column>
					<el-table-column prop="passScore" label="状态" width='100' align="center">
						<template slot-scope="scope">
							<el-tag type='primary' v-if='scope.row.state == 0'>已经开考</el-tag>
							<el-tag type='success' v-if='scope.row.state == 1'>考核结束</el-tag>
							<el-tag type='info' v-if='scope.row.state == 2'>考试异常</el-tag>
							<el-tag type='danger' v-if='scope.row.state == 3'>未参考</el-tag>
						</template>
					</el-table-column>
					<el-table-column label="操作" width='150' align="center">
						<template slot-scope="scope">
								<el-button v-if='scope.row.state == 0' size="mini" type="primary" @click="startexamine(scope.row)" :disabled='getDisabld(scope.row)'>{{getDisabld(scope.row)?'不在考核时间内':'进入考核'}}</el-button>
								<el-button v-if='scope.row.state == 3' size="mini" type="primary" @click="startexamine(scope.row)" :disabled='getDisabld(scope.row)'>{{getDisabld(scope.row)?'不在考核时间内':'进入考核'}}</el-button>
								<el-button v-if='scope.row.state == 1' size="mini" type="primary" @click="examineit(scope.row)">查看详情</el-button>
							</template>
					</el-table-column>
				</el-table>
				<div class="table-page" >
					 <el-pagination background @current-change="examinePageChange" :current-page="page" :page-size="pageSize" layout=" prev, pager, next" :total="totalRow">
					</el-pagination>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import { getLoginUserExamList } from '@/api/examine'
	export default {
		data() {
			return {
				page: 1,
				pageSize: 10,
				totalRow: 0,
				dataList: [],
				form: {
					examineName: '',
					state: '',
				},
				types: [{
					value: '0',
					label: '考试中'
				}, {
					value: '1',
					label: '考试结束'
				}, {
					value: '2',
					label: '考试异常'
				}, {
					value: '3',
					label: '未参考'
				}],
			};
		},
		created() {
			this.getExamList()
		},
		methods: {
			getDisabld(item){
				var nowTime = new Date();
				var beginTime = new Date(item.beginTime.split('T').join(' '));
				var endTime = new Date(item.endTime.split('T').join(' '));
				if(nowTime>beginTime && nowTime<endTime){
					return false
				}else{
					return true
				}
			},
			startexamine(item) {
				var nowTime = new Date();
				var beginTime = new Date(item.beginTime.split('T').join(' '));
				var endTime = new Date(item.endTime.split('T').join(' '));
				if(nowTime<beginTime){
					this.$message({
						type:'info',
						message:'考试时间未到！',
					})
					return;
				}
				if(nowTime>endTime){
					this.$message({
						type:'info',
						message:'考试时间已结束！',
					})
					return;
				}
				this.$router.push({
					name: 'examine',
					query: {
						id: item.id
					}
				})
			},
			examineit(item){
				this.$router.push({
					name: 'examdetails',
					query: {
						id: item.id
					}
				})
			},
			onSubmit() {
				this.page = 1
				this.getExamList()
			},
			examinePageChange(page) {
				this.examinePage = page;
				this.getExamList()
			},
			getExamList() {
				var data = {
					page: this.page,
					pageSize: this.pageSize,
					examineName: this.form.examineName,
					state: this.form.state,
				}
				getLoginUserExamList(data).then(res => {
					if(res.code == 0) {
						this.dataList = res.data.listData;
						this.totalRow = res.data.totalRow;
					}
				})
			}

		}
	}
</script>